module.exports = __webpack_public_path__ + "img/INCNT.c93b3d7e.svg";